/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useMemo } from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';
import {
  invoiceQuarterCells,
  invoiceFamilyCells,
} from './gridComponents/tableHead';
import { getInvoiceQuarter } from '../store/actions';
import LinksButtonRender from './linksButtonRender';
import {
  currencyFormatter,
  removeCommaForNumberFiled,
  removeDollarForNumberFiled,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

export default function InvoiceQuarterTab(props) {
  const dispatch = useDispatch();
  const frameworkComponents = {
    LinksButtonRender: LinksButtonRender,
  };
  const { invoiceDetailsByInvoiceNum, setFullScreenView, fullScreenView } =
    props;

  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [filterApply, setFilterApply] = React.useState(false);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const invoiceQuarter = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceQuarter
  );

  useEffect(() => {
    if (!(invoiceQuarter?.length > 0)) {
      dispatch(
        getInvoiceQuarter({
          invoiceNum: invoiceDetailsByInvoiceNum?.invoiceNum,
          planTypeCode: invoiceDetailsByInvoiceNum?.planTypeCode,
        })
      );
    }
  }, []);
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };
  

  const toNum = (v) => {
    if (v === undefined || v === null || v === '') return 0;
    if (typeof v === 'number') return v;
    const s = String(v).replace(/[$,]/g, '');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  }
  
  const invoiceQuarterRows = useSelector(
    (s) => s?.sharedState?.DisplayInvoiceReducer?.invoiceQuarter
  );
  const currentAmountFromGrid = useMemo(() => {
      const rows = invoiceQuarterRows || [];
      return rows.reduce((acc, r) => acc + Math.round(toNum(r?.totalRebateAmt) * 100) / 100, 0);
    }, 
    [invoiceQuarterRows]
  );
  // Total Count on Table Cells Starts
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : invoiceQuarter || [];
    const data = displayedRows?.reduce((accumulator, object) => {
      return accumulator + Math.round(toNum(object?.[property]) * 100) / 100;
    }, 0);
    // const data = displayedRows?.reduce((accumulator, object) => {
    //   return (
    //     parseFloat(
    //       removeDollarForNumberFiled(removeCommaForNumberFiled(accumulator))
    //     ) +
    //     parseFloat(
    //       removeDollarForNumberFiled(
    //         removeCommaForNumberFiled(object[property])
    //       )
    //     )
    //   );
    // }, 0);

    return data.toFixed(2);
  };

  const createData = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        rowPinned: true,
        isBottomRow: true,
        unitRebateAmt: '', // sum('unitRebateAmt'),
        totalReimsedUnit: sum('totalReimsedUnit'),
        stateAmtReimbursed: sum('stateAmtReimbursed'),
        totalRebateAmt: sum('totalRebateAmt'),
        deductibleAmt: sum('deductibleAmt'),
        tplAmt: sum('tplAmt'),
        copayAmt: sum('copayAmt'),
        totalReimsedAmt: sum('totalReimsedAmt'),
        amountDue: sum('amountDue'),
        wacPrice: sum('wacPrice'),
        noOfPrescription: undefined,
      });
    }
    return result;
  };

  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [invoiceQuarter, filteredRows, filterApply]);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.invoiceNum;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        INVOICE_NUM: invoiceDetailsByInvoiceNum?.invoiceNum,
        // { selectedRow },
      });
    }
  };

  // Total Count on Table Cells Ends

  return (
    <>
      <div style={{ marginTop: '0px' }}>
        {!fullScreenView && (
          <fieldset className="custom-fieldset">
            <legend>Totals</legend>
            <div className="form-wrapper">
              <div
                className={`mui-custom-form with-select input-md frr-text-right ${
                  invoiceDetailsByInvoiceNum?.originalInvoiceQtrAmt !== null &&
                  parseFloat(
                    invoiceDetailsByInvoiceNum?.originalInvoiceQtrAmt
                  ) < 0
                    ? 'negativeValue'
                    : 'positiveValue'
                }`}
              >
                <TextField
                  id="original_amount"
                  label="Original Amount"
                  fullWidth
                  placeholder=""
                  value={currencyFormatter(
                    invoiceDetailsByInvoiceNum?.originalInvoiceQtrAmt,
                    '$'
                  )}
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div
                className={`mui-custom-form with-select input-md frr-text-right ${
                  invoiceDetailsByInvoiceNum?.totCurrQtrAmt !== null &&
                  parseFloat(invoiceDetailsByInvoiceNum?.totCurrQtrAmt) < 0
                    ? 'negativeValue'
                    : 'positiveValue'
                }`}
              >
                <TextField
                  id="current_amount"
                  label="Current Amount"
                  fullWidth
                  placeholder=""
                  // value={currencyFormatter(
                  //   invoiceDetailsByInvoiceNum?.totCurrQtrAmt,
                  //   '$'
                  // )}
                  value={currencyFormatter( currentAmountFromGrid, '$' )}
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div
                className={`mui-custom-form with-select input-md frr-text-right ${
                  invoiceDetailsByInvoiceNum?.invoiceBalance !== null &&
                  parseFloat(invoiceDetailsByInvoiceNum?.invoiceBalance) < 0
                    ? 'negativeValue'
                    : 'positiveValue'
                }`}
              >
                <TextField
                  id="balance"
                  label="Balance"
                  fullWidth
                  placeholder=""
                  value={currencyFormatter(
                    invoiceDetailsByInvoiceNum?.invoiceBalance,
                    '$'
                  )}
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
          </fieldset>
        )}
        <div className="frr-tbl-with-feature">
          <Grid
            pinnedBottomRowData={pinnedBottomRowData}
            onFilterData={onFilterChanged}
            getFilterApply={getFilterApply}
            gridHeight={fullScreenView ? '100vh' : 350}
            rowData={invoiceQuarter || []}
            columnDefs={
              invoiceDetailsByInvoiceNum?.planTypeCode === 'COMM' ||
              invoiceDetailsByInvoiceNum?.planTypeCode === 'SUPP'
                ? invoiceFamilyCells
                : invoiceQuarterCells
            }
            noGlobalSort
            data-testid="onEditingStopped"
            enterMovesDown
            isScrollOn
            suppressCellFocus
            onCellFocused={onCellFocused}
            singleClickEdit={false}
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenViewClick}
            exportFile
            fileName="Invoice Quarter"
            // handleViewHistory={handleViewHistory}
            frameworkComponents={{
              frameworkComponents,
              AmountComponent: CustomGridCellRendererComponent,
              UnitRebateAmtCellRender: (cellInfo) => {
                const value = parseFloat(cellInfo?.value);
                if (cellInfo?.data?.isBottomRow) {
                  // const pinnedValue = parseFloat(cellInfo?.value);
                  // if (pinnedValue < 0) {
                  //   return (
                  //     <b>
                  //       <span style={{ color: '#eb0000' }}>
                  //         (
                  //         {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString(
                  //           'en-US',
                  //           {
                  //             minimumFractionDigits: 6,
                  //             maximumFractionDigits: 6,
                  //           }
                  //         )}`}
                  //         )
                  //       </span>
                  //     </b>
                  //   );
                  // }
                  // if (pinnedValue) {
                  //   return (
                  //     <b>
                  //       {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                  //         minimumFractionDigits: 6,
                  //         maximumFractionDigits: 6,
                  //       })}`}
                  //     </b>
                  //   );
                  // }
                  return ''; // <b> 0.000000</b>;
                }
                if (value < 0) {
                  return (
                    <span style={{ color: '#eb0000' }}>
                      (
                      {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                        minimumFractionDigits: 6,
                        maximumFractionDigits: 6,
                      })}
                      )
                    </span>
                  );
                }
                if (value) {
                  return ` ${parseFloat(value)?.toLocaleString('en-US', {
                    minimumFractionDigits: 6,
                    maximumFractionDigits: 6,
                  })}`;
                }
                return ' 0.000000';
              },
              NumOfUnitsCellRender: (cellInfo) => {
                const value = parseFloat(cellInfo?.value);
                if (cellInfo?.data?.isBottomRow) {
                  const pinnedValue = parseFloat(cellInfo?.value);
                  if (pinnedValue < 0) {
                    return (
                      <b>
                        <span style={{ color: '#eb0000' }}>
                          (
                          {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString(
                            'en-US',
                            {
                              minimumFractionDigits: 4,
                              maximumFractionDigits: 4,
                            }
                          )}`}
                          )
                        </span>
                      </b>
                    );
                  }
                  if (pinnedValue) {
                    return (
                      <b>
                        {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                          minimumFractionDigits: 4,
                          maximumFractionDigits: 4,
                        })}`}
                      </b>
                    );
                  }
                  return <b> 0.0000</b>;
                }
                if (value < 0) {
                  return (
                    <span style={{ color: '#eb0000' }}>
                      (
                      {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                        minimumFractionDigits: 4,
                        maximumFractionDigits: 4,
                      })}
                      )
                    </span>
                  );
                }
                if (value) {
                  return ` ${parseFloat(value)?.toLocaleString('en-US', {
                    minimumFractionDigits: 4,
                    maximumFractionDigits: 4,
                  })}`;
                }
                return ' 0.0000';
              },
              nameRenderDrugName: (cellInfo) => {
                const name = cellInfo.data && cellInfo.data.drugName;
                if (name && name.length > 23) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
              nameRenderNdc: (cellInfo) => {
                const name = cellInfo.data && cellInfo.data.ndc;
                if (name && name.length > 13) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
            hideColumnsInPdf={['actions']}
          />
        </div>
        {showViewHistory ? (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="INVOICE_HEADER"
            keyValue={keyValue}
          />
        ) : null}
      </div>
    </>
  );
}
